export default __webpack_public_path__ + "static/idea-illus-77d74db9fc14c2df9c234c8e7c446628.svg";